<div class="beacon-style-panel">
    <small class="debug">{{ me }}</small>
    @if (dynamicsInitialized) {
        <div class="settings-section">
            <div class="properties-section">
                <div class="prop-section-header">
                    <mat-icon class="prop-section-icon">view_quilt</mat-icon>
                    <span class="prop-section-title">layout</span>
                </div>
                <div class="section-content">
                    <mat-form-field class="style-selector" appearance="outline"
                                    matTooltip="Row layout — table or stacked tiles. Colors and fonts stay as configured."
                                    matTooltipPosition="left">
                        <mat-label>display mode</mat-label>
                        <mat-select [(ngModel)]="displayMode" (selectionChange)="saveToStore()">
                            @for (opt of displayModeOptions; track opt.value) {
                                <mat-option [value]="opt.value">
                                    <mat-icon>{{ opt.icon }}</mat-icon>
                                    {{ opt.label }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    @if (displayMode === 'tile') {
                        <mat-form-field class="style-selector" appearance="outline"
                                        matTooltip="Split the tiles across this many side-by-side columns."
                                        matTooltipPosition="left">
                            <mat-label>columns</mat-label>
                            <mat-select [(ngModel)]="columns" (selectionChange)="saveToStore()">
                                @for (n of columnOptions; track n) {
                                    <mat-option [value]="n">
                                        <mat-icon>view_column</mat-icon>
                                        {{ n }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                </div>
            </div>

            <div class="properties-section">
                <div class="prop-section-header">
                    <mat-icon class="prop-section-icon">title</mat-icon>
                    <span class="prop-section-title">title</span>
                </div>
                <div class="section-content">
                    <div class="toggle-row">
                        <mat-slide-toggle [(ngModel)]="showTitle" (change)="saveToStore()"
                                          matTooltip="show station/players title above the table"
                                          matTooltipPosition="left">
                            show title
                        </mat-slide-toggle>
                    </div>
                    <div class="toggle-row">
                        <mat-slide-toggle [(ngModel)]="showFound" (change)="saveToStore()"
                                          matTooltip="append ✓ found count to the title"
                                          matTooltipPosition="left">
                            show found
                        </mat-slide-toggle>
                    </div>
                    <div class="toggle-row">
                        <mat-slide-toggle [(ngModel)]="showMissing" (change)="saveToStore()"
                                          matTooltip="append ✗ missing count to the title"
                                          matTooltipPosition="left">
                            show missing
                        </mat-slide-toggle>
                    </div>
                    <div class="toggle-row">
                        <mat-slide-toggle [(ngModel)]="showTotal" (change)="saveToStore()"
                                          matTooltip="append total count to the title"
                                          matTooltipPosition="left">
                            show total
                        </mat-slide-toggle>
                    </div>
                </div>
            </div>

            <div class="properties-section">
                <div class="prop-section-header">
                    <mat-icon class="prop-section-icon">view_column</mat-icon>
                    <span class="prop-section-title">columns</span>
                </div>
                <div class="section-content">
                    <div class="toggle-row">
                        <mat-slide-toggle [(ngModel)]="showRssi" (change)="saveToStore()"
                                          matTooltip="show the device RSSI column (configured station)"
                                          matTooltipPosition="left">
                            show rssi
                        </mat-slide-toggle>
                    </div>
                    <div class="toggle-row">
                        <mat-slide-toggle [(ngModel)]="showClosest" (change)="saveToStore()"
                                          matTooltip="show the CLOSEST station-name column"
                                          matTooltipPosition="left">
                            show closest
                        </mat-slide-toggle>
                    </div>
                    <div class="toggle-row">
                        <mat-slide-toggle [(ngModel)]="showClosestRssi" (change)="saveToStore()"
                                          matTooltip="show the closest-station RSSI column"
                                          matTooltipPosition="left">
                            show closest rssi
                        </mat-slide-toggle>
                    </div>
                    <div class="toggle-row">
                        <mat-slide-toggle [(ngModel)]="showLastSeen" (change)="saveToStore()"
                                          matTooltip="show the LAST SEEN (relative time) column"
                                          matTooltipPosition="left">
                            show last seen
                        </mat-slide-toggle>
                    </div>
                </div>
            </div>

            <div class="properties-section">
                <div class="prop-section-header">
                    <mat-icon class="prop-section-icon">format_color_fill</mat-icon>
                    <span class="prop-section-title">colors</span>
                </div>
                <div class="section-content">
                    <div class="separator-color-row" matTooltip="Color of the horizontal rules (under title + header) and the vertical column separator." matTooltipPosition="left">
                        <span class="separator-color-label">separator color</span>
                        <input class="separator-color-swatch"
                               [colorPicker]="separatorColorHex"
                               [style.background]="separatorColorHex"
                               [value]="separatorColorHex"
                               [readonly]="true"
                               [cpPosition]="'bottom'"
                               (colorPickerChange)="separatorColorHex = $event; saveToStore()"/>
                    </div>
                </div>
            </div>

            <div class="properties-section">
                <div class="prop-section-header">
                    <mat-icon class="prop-section-icon">title</mat-icon>
                    <span class="prop-section-title">title font</span>
                </div>
                <div class="section-content">
                    @if (titleFontConfig?.Font) {
                        <app-font-selector (onChange)="onFontChanged($event, 'Title', 'Beacon')"
                                           [setConfig]="{i_config: titleFontConfig}"
                                           [hideAlignment]="true"></app-font-selector>
                    }
                </div>
            </div>

            <div class="properties-section">
                <div class="prop-section-header">
                    <mat-icon class="prop-section-icon">table_rows</mat-icon>
                    <span class="prop-section-title">table font</span>
                </div>
                <div class="section-content">
                    @if (tableFontConfig?.Font) {
                        <app-font-selector (onChange)="onFontChanged($event, 'Table', 'Beacon')"
                                           [setConfig]="{i_config: tableFontConfig}"
                                           [hideAlignment]="true"></app-font-selector>
                    }
                </div>
            </div>
        </div>
    }
</div>
